import React from "react";
import { motion } from "framer-motion";
import { Medal, Eye, HandHeart } from "@phosphor-icons/react";
import { useLanguage } from "@/context/LanguageContext";

const icons = [Medal, Eye, HandHeart];

export default function AboutSection() {
  const { t } = useLanguage();

  return (
    <section id="nosotros" className="py-24 md:py-32 bg-[#050505]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img src="https://images.unsplash.com/photo-1718116325027-1928c85a10c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHx1cGhvbHN0ZXJ5fGVufDB8fHx8MTc3NjIwNzg2MHww&ixlib=rb-4.1.0&q=85" alt="Craftsmanship" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-6 -right-6 md:right-6 bg-[#121212] border border-white/10 p-6 md:p-8">
              <p className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#FFD700] font-light">15+</p>
              <p className="text-zinc-400 text-xs uppercase tracking-wider mt-1">{t.about.years}</p>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700] mb-4 font-light">{t.about.overline}</p>
            <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-white tracking-tight mb-8">{t.about.title}</h2>
            <p className="text-base text-zinc-300 font-light leading-relaxed mb-6">{t.about.p1}</p>
            <p className="text-base text-zinc-300 font-light leading-relaxed mb-12">{t.about.p2}</p>

            <div className="space-y-6">
              {t.about.values.map((v, i) => {
                const Icon = icons[i];
                return (
                  <div key={i} className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center border border-[#FFD700]/30">
                      <Icon size={20} weight="duotone" className="text-[#FFD700]" />
                    </div>
                    <div>
                      <h4 className="text-white text-sm font-medium mb-1">{v.title}</h4>
                      <p className="text-zinc-400 text-sm font-light">{v.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
